<template>
  <div class="direction-column _br-2 _bg-light _px-6 _py-4 drop-item_single">
    <AppBtn
      @click.native="dataLayerPush"
      class="_mb-2 w-100 w-md-auto drop-link"
    >
      <router-link
        v-if="
          item.href &&
          Object.keys(item.href).length &&
          typeof item.href === 'object'
        "
        :to="helpers.buildRoute(item.href)"
      >
        <span class="d-flex align-center drop-link_svg">
          <img :src="item.svg" alt="" />
        </span>
      </router-link>
      <a v-else :href="item.href" :download="item.download" target="_blank">
        <span class="d-flex align-center drop-link_svg">
          <img :src="item.svg" alt="" />
        </span>
      </a>
    </AppBtn>
    <div class="_fs-16 _lh-20 _fw-700 _tc-dark _mb-2" v-html="item.title"></div>
    <div class="_fs-16 _lh-24 _tc-dark-grey" v-html="item.description"></div>
  </div>
</template>

<script>
import AppBtn from './buttons/AppBtn.vue'
export default {
  components: { AppBtn },
  name: 'DropElement',
  props: {
    item: Object,
  },
  data: () => ({}),
  methods: {
    dataLayerPush() {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'resources_links',
          param_value: this.helpers.stripHtml(this.item.title),
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.drop-item {
  &_single {
    border-radius: 16px;
    width: 100%;
  }
}
.drop-link {
  width: 32px;
  height: 32px;
}
</style>
